import React, { useState } from "react";
import { useRecipesCRUD } from "../api/recipesHooks";
import { FormWrapper } from "./forms/FormWrapper";
import { Recipe } from "./Recipe";
import { TileList } from "./generic/TileList";
import { Button } from "./generic/Button";
import { ManageRecipe } from "./forms/ManageRecipe";
const lebensmittel = [
  "Brot",
  "Milch",
  "Eier",
  "Butter",
  "Käse",
  "Joghurt",
  "Tomaten",
  "Gurke",
  "Salat",
  "Zwiebeln",
  "Kartoffeln",
  "Karotten",
  "Äpfel",
  "Bananen",
  "Orangen",
  "Reis",
  "Nudeln",
  "Mehl",
  "Zucker",
  "Salz",
  "Pfeffer",
  "Öl",
  "Essig",
  "Kaffee",
  "Tee",
  "Mineralwasser",
  "Hähnchenbrust",
  "Rindfleisch",
  "Fisch (Lachs)",
  "Wurst",
  "Schinken",
  "Müsli",
  "Haferflocken",
  "Marmelade",
  "Honig",
  "Schokolade",
  "Kekse",
  "Tiefkühlgemüse",
  "Pizza (TK)",
  "Dosenbohnen",
  "Dosentomaten",
  "Ketchup",
  "Senf",
  "Mayonnaise",
  "Zitronen",
  "Knoblauch",
  "Kräuter (frisch/getrocknet)",
  "Quark",
  "Eiscreme",
  "Wein",
];

export const RecipesList = ({ onClose, listId, addProduct, products }) => {
  const {
    recipes,
    loading,
    error,
    addRecipe,
    updateRecord: updateRecipe,
    deleteRecord,
  } = useRecipesCRUD(listId);

  const [addModalOpen, setAddModalOpen] = useState(false);
  const [recipeToEdit, setRecipeToEdit] = useState(null);

  return (
    <FormWrapper>
      <div
        style={{
          height: "100%",
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
        }}
      >
        <TileList>
          {recipes.map((recipe) => {
            return (
              <Recipe
                recipe={recipe}
                key={recipe.id}
                onDelete={deleteRecord}
                addProduct={addProduct}
                products={products}
                setRecipeToEdit={setRecipeToEdit}
                loading={loading}
              />
            );
          })}
        </TileList>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "1rem",
            marginTop: "2rem",
          }}
        >
          <Button onClick={() => setAddModalOpen(true)}>➕ Neues Rezept</Button>
          <Button onClick={onClose}>⊘ Schließen</Button>
        </div>

        {/* MODALS */}

        {addModalOpen ? (
          <ManageRecipe
            mode="add"
            onClose={() => setAddModalOpen(false)}
            onSubmit={addRecipe}
            recipes={recipes || []}
          />
        ) : null}

        {recipeToEdit ? (
          <ManageRecipe
            mode="edit"
            onClose={() => setRecipeToEdit(null)}
            onSubmit={updateRecipe}
            recipes={recipes || []}
            recipeToEdit={recipeToEdit}
          />
        ) : null}
      </div>
    </FormWrapper>
  );
};
